'use strict';

exports.__esModule = true;
exports['default'] = hoc;

var _validators = require('../../utils/validators');

function hoc(containerComponent) {
  for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return function (target) {
    (0, _validators.validateClass)(target, 'hoc');

    return params.length === 0 ? containerComponent(target) : containerComponent.apply(undefined, params)(target);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/hoc.js
// module id = 550
// module chunks = 1